import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */
import { OV_EMS_CDN } from '../../config/theme';
var DEFAULT_ALT = "Outdoor Voices - TechSweat\u2122 Leggings";
var imgRoot = "".concat(OV_EMS_CDN, "media/pages/techsweat/");
var hero = {
  subtitle: 'Explore',
  cta: {
    href: '/collections/techsweat-leggings',
    text: 'Shop TechSweat™ Leggings',
    white: true
  },
  image: {
    alt: DEFAULT_ALT,
    src: "".concat(imgRoot, "hero_desktop.jpg"),
    width: 2400,
    sizes: [2400, 1600, 1200, 800, 480]
  },
  title: 'TechSweat™ Leggings'
};

var heroMobile = _objectSpread(_objectSpread({}, hero), {}, {
  image: {
    alt: DEFAULT_ALT,
    src: "".concat(imgRoot, "hero_mobile.jpg"),
    width: 375,
    sizes: [800, 480]
  }
});

var fabricDescription = {
  description: 'TechSweat™ provides an extra-secure fit, giving you the freedom to move confidently. Because high-intensity needs awesome flexibility, we designed this cool-to-the-touch fabric to keep you Doing Things, even during the sweatiest workouts.',
  image: {
    alt: 'Fabric Swatch',
    src: "".concat(imgRoot, "swatch.jpg"),
    width: 577,
    sizes: [1200, 800, 261]
  },
  title: 'TechSweat™ —<br> The Name Says It All'
};
var shopSegments = {
  segments: [{
    label: 'Core',
    title: 'OV Core Band',
    description: "Bonded and structured, this hi-rise waistband hugs your shape and stays put for extra confidence when you're chasing serious endorphins — complete with a secure back pocket for phone and key storage.",
    cta: 'Shop Core Band Leggings',
    url: '/collections/techsweat-leggings#core-band',
    image: {
      alt: 'OV Core Band',
      src: "".concat(imgRoot, "core.jpg"),
      width: 615,
      sizes: [800, 480]
    }
  }, {
    label: 'Flex',
    title: 'OV Flex Band',
    description: 'Mid-rise, soft and flexible, this waistband is built for unrestricted movement – including a hidden front pocket for key and snack storage.',
    cta: 'Shop Flex Band Leggings',
    url: '/collections/techsweat-leggings#flex-band',
    image: {
      alt: 'OV Flex Band',
      src: "".concat(imgRoot, "flex.jpg"),
      width: 615,
      sizes: [800, 480]
    }
  }],
  title: 'Find The Right Waistband'
};
var ugcImage = {
  alt: '@missboddington',
  src: "".concat(imgRoot, "TSW_UGC1.jpg"),
  width: 375,
  sizes: [800, 480]
};
var ugc = {
  images: [_objectSpread({}, ugcImage), _objectSpread(_objectSpread({}, ugcImage), {}, {
    alt: '@elainewelteroth',
    src: "".concat(imgRoot, "TSW_UGC2.jpg")
  }), _objectSpread(_objectSpread({}, ugcImage), {}, {
    alt: '@calahjones',
    src: "".concat(imgRoot, "TSW_UGC3.jpg")
  }), _objectSpread(_objectSpread({}, ugcImage), {}, {
    alt: '@michellesalem',
    src: "".concat(imgRoot, "TSW_UGC4.jpg")
  }), _objectSpread(_objectSpread({}, ugcImage), {}, {
    alt: '@ellaswelfer',
    src: "".concat(imgRoot, "TSW_UGC5.jpg")
  }), _objectSpread(_objectSpread({}, ugcImage), {}, {
    alt: '@kendramorous',
    src: "".concat(imgRoot, "TSW_UGC6.jpg")
  }), _objectSpread(_objectSpread({}, ugcImage), {}, {
    alt: '@patricia_zhou',
    src: "".concat(imgRoot, "TSW_UGC7.jpg")
  }), _objectSpread(_objectSpread({}, ugcImage), {}, {
    alt: '@olivarneson',
    src: "".concat(imgRoot, "TSW_UGC8.jpg")
  })],
  title: 'TechSweat™ In The Wild'
};
var footer = {
  title: 'Sweat With Confidence',
  cta: 'Shop TechSweat™ Leggings',
  url: '/collections/techsweat-leggings',
  posterDesktop: "".concat(imgRoot, "footer_poster_desktop.jpg"),
  posterMobile: "".concat(imgRoot, "footer_poster_mobile.jpg"),
  videoDesktop: "".concat(imgRoot, "footer_video_desktop.mp4"),
  videoMobile: "".concat(imgRoot, "footer_video_desktop.mp4"),
  video: {
    muted: false
  }
};
var props = {
  fabricDescription: fabricDescription,
  hero: hero,
  heroMobile: heroMobile,
  shopSegments: shopSegments,
  ugc: ugc,
  footer: footer
};
export default props;